module.exports = __webpack_public_path__ + "static/media/tomcat.415cd59d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/tomcat.png
// module id = 204
// module chunks = 0